import '../styles/main.scss';
import './views/main';
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();
